import script from "./top.vue?vue&type=script&setup=true&lang=js"
export * from "./top.vue?vue&type=script&setup=true&lang=js"

import "./top.vue?vue&type=style&index=0&id=0ecf8be8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.18_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ecf8be8"]])

export default __exports__